import { ProgramModel } from './program.model';

export class DiscProgramModel {
  public id: number = null;
  public position: number = null;
  public program: ProgramModel = new ProgramModel();

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: DiscProgramModel[] = [];
    if (jsons) {
      jsons.forEach(json => {
        refs.push(new DiscProgramModel().fromJSON(json));
      });
    }
    return refs;
  }
}
